export default function UploadService($rootScope, $q, $http, API) {
  'ngInject'

  function uploadWithPresignedUrl(nameFolder, fileName, file, fileType, progressEvent, defer) {
    $http
      .get(API.API_URL + 'upload_presign', {
        params: {
          folder_path: nameFolder,
          file_name: fileName,
          file_type: fileType,
          file_size: file.size,
        },
      })
      .then(function (response) {
        var url = response.data && response.data.presigned_url
        if (!url) {
          defer.reject('No presigned url')
        }
        var xhr = new XMLHttpRequest()
        xhr.open('PUT', url)

        xhr.setRequestHeader('Content-Type', fileType)
        xhr.setRequestHeader('x-amz-acl', 'public-read')
        xhr.setRequestHeader('x-amz-server-side-encryption', 'AES256')
        xhr.setRequestHeader('Cache-Control', 'public,max-age=31536000')

        xhr.upload.addEventListener('progress', function (evt) {
          if (evt.lengthComputable) {
            const percent = Math.round((evt.loaded / evt.total) * 100)
            if (progressEvent === 'batchUploadProgress') {
              $rootScope.$broadcast('batchUploadProgress', percent + '%')
            } else {
              $rootScope.$broadcast('uploadProgress', percent + '%')
            }
          }
        })

        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            defer.resolve(fileName)
          } else {
            defer.reject(xhr.responseText || 'Http error: ' + xhr.status)
          }
        }

        xhr.onerror = function () {
          defer.reject('Network error')
        }

        xhr.send(file)
      })
      .catch(function (err) {
        defer.reject(err)
      })
  }

  function save(nameFolder, file, model, id, qmf) {
    var defer = $q.defer()

    var extension
    var fileName
    var fileType = file.type
    if (qmf === undefined) {
      if (file.type != '') {
        extension = file.type.split('/')[1]
      }
      if (extension === 'quicktime') {
        extension = 'mp4'
        fileType = 'video/mp4'
      }

      if (!extension && file.name.indexOf('glb') !== -1) {
        extension = 'glb'
      } else if (!extension && file.name.indexOf('gltf') !== -1) {
        extension = 'gltf'
      }
    }

    if (qmf !== undefined) {
      fileName = file.name + '-' + new Date().getTime()
    } else {
      if (id === undefined) {
        id = 0
      }
      if (isNaN(id)) {
        id = 0
      }

      if (id === 0) {
        fileName = model + '-' + new Date().getTime() + '.' + extension
      } else {
        fileName = id + '-' + model + '-' + new Date().getTime() + '.' + extension
      }
    }

    uploadWithPresignedUrl(nameFolder, fileName, file, fileType, 'uploadProgress', defer)

    return defer.promise
  }

  function saveFixed(nameFolder, file, fileName) {
    var defer = $q.defer()

    uploadWithPresignedUrl(nameFolder, fileName, file, file.type, 'uploadProgress', defer)

    return defer.promise
  }

  function saveBatch(nameFolder, file, name) {
    var defer = $q.defer()

    var extension = file.type.split('/')[1]
    var fileNameZip = name + '-' + new Date().getTime() + '.' + extension

    uploadWithPresignedUrl(nameFolder, fileNameZip, file, file.type, 'batchUploadProgress', defer)

    return defer.promise
  }

  function saveQmf(nameFolder, file, name, collectibleId) {
    var defer = $q.defer()

    var nameFile = file.name.split('.')[0]
    var fileNameZip = nameFile + '-' + collectibleId + '-' + new Date().getTime() + '.' + 'zip'

    uploadWithPresignedUrl(nameFolder, fileNameZip, file, file.type, 'uploadProgress', defer)

    return defer.promise
  }

  function savePromo(nameFolder, file, promoId) {
    var defer = $q.defer()

    var extension = file.name.split('.').pop()
    var fileNameZip = promoId + '-' + new Date().getTime() + '.' + extension

    uploadWithPresignedUrl(nameFolder, fileNameZip, file, file.type, 'uploadProgress', defer)

    return defer.promise
  }

  function get(nameFolder) {
    var defer = $q.defer()
    defer.resolve([])
    return defer.promise
  }

  function deleteFile(nameFolder, fileName) {
    var defer = $q.defer()

    if (!fileName) {
      defer.resolve()
      return defer.promise
    }

    var key = nameFolder + '/' + fileName

    $http({
      method: 'DELETE',
      url: API.API_URL + 's3_object',
      params: { file_path: key },
    }).then(
      function (response) {
        defer.resolve(response.data)
      },
      function (err) {
        defer.reject(err)
      },
    )

    return defer.promise
  }

  function deletePhoto(fileName, id) {
    return deleteFile('users', fileName)
  }

  function deletePhotoCover(fileName) {
    return deleteFile('users', fileName)
  }

  return {
    save: save,
    saveFixed: saveFixed,
    saveBatch: saveBatch,
    get: get,
    saveQmf: saveQmf,
    savePromo: savePromo,
    deletePhoto: deletePhoto,
    deletePhotoCover: deletePhotoCover,
    deleteFile: deleteFile,
  }
}
